import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import girl2Img from '../../../images/webp/girl-2.webp';
import React from 'react';

const ContactForm = () => {
    const formSubmitHandler = e => {
        document.getElementById('nameInput').value = '';
        document.getElementById('emailInput').value = '';
        document.getElementById('phoneInput').value = '';
        document.getElementById('messageInput').value = '';
        alert('Something wrong please try again after some time.!!!')
        e.preventDefault();
    }
    return (
        <div>
            <div className="row align-items-center">
                <div className="col-md-6">
                    <div style={{ background: '#FF547D', color: 'white', padding: 10, borderRadius: 10, margin: '15px 5px' }}>
                        <h5 data-aos="fade-up" data-aos-duration="500">Book your event</h5>
                        <h3 data-aos="fade-up" data-aos-duration="1500">+880 1870 289 584</h3>
                        <p data-aos="fade-up" data-aos-duration="2500">Monday - Friday <b>09:00 AM - 06:00 PM</b></p>
                        <p data-aos="fade-up" data-aos-duration="3000">Saturday 07:00 AM - 08:00 PM</p>
                        <h4 data-aos="fade-up" data-aos-duration="3000" className="text-end style-font">Call us now!</h4>
                    </div>
                    <div style={{ background: '#ffe9c2', color: 'black', padding: 10, borderRadius: 10, margin: '15px 5px' }}>
                        <div className='row align-items-end'>
                            <div className="col-7">
                                <h4 data-aos="fade-up" data-aos-duration="500" className="fw-bolder">Online consultant</h4>
                                <h5 data-aos="fade-up" data-aos-duration="1500" className="mt-3">Darlene Robertson</h5>
                                <p data-aos="fade-up" data-aos-duration="2500">Lorem, ipsum dolor sit amet consectetur adipisicing.</p>
                                <button data-aos="fade-up" data-aos-duration="3000" className="btn rounded-pill btn-global-style">
                                    See events <FontAwesomeIcon icon={faArrowRight} />
                                </button>
                            </div>
                            <div className="col-5">
                                <img data-aos="flip-left" data-aos-duration="3000" className="w-100" src={girl2Img} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <h2 data-aos="fade-up" data-aos-duration="500">Have a question? <br /> Write to us!</h2>
                    <form onSubmit={formSubmitHandler}>
                        <input data-aos="fade-up" data-aos-duration="1000" id="nameInput" type="text" className="form-control mt-2" placeholder="Full Name *" />
                        <input data-aos="fade-up" data-aos-duration="1500" id="phoneInput" type="number" className="form-control mt-2" placeholder="Phone *" />
                        <input data-aos="fade-up" data-aos-duration="2000" id="emailInput" type="email" className="form-control mt-2" placeholder="Email address *" />
                        <textarea data-aos="fade-up" data-aos-duration="2500" id="messageInput" type="text" className="form-control mt-2" placeholder="Your message.." />
                        <input data-aos="fade-up" data-aos-duration="3000" type="checkbox" name="" id="" /> I consent to the processing of data for the purpose of telephone contact. *
                        <br />
                        <input data-aos="fade-down" data-aos-duration="2000" type="submit" value="Send a message" className="form-control btn rounded-pill btn-global-style-solid" />
                    </form>
                    <p data-aos="fade-down" data-aos-duration="3000">
                        There was an error trying to send your message. Please try again later.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ContactForm;